import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1fb2fff6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "move-info"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "move-info__label"
}, "当前模块", -1));
const _hoisted_3 = {
  class: "move-info__value"
};
const _hoisted_4 = {
  class: "move-info__name"
};
const _hoisted_5 = {
  key: 0,
  class: "move-info__code"
};
import { computed, reactive, ref, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleMoveModal',
  props: {
    visible: {
      type: Boolean
    },
    module: null,
    columns: null,
    onSubmit: null
  },
  emits: ["update:visible"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    /**
     * 模块「移动到其它栏目」专属弹窗
     * - 只承担归属切换；底层走 /setting/module/save，columnId 改为目标栏目 id
     * - 当前栏目从下拉选项中过滤掉（避免自己移到自己）
     * - 父层通过 onSubmit 注入移动方法（返回 boolean 控制弹窗关闭）
     */
    const open = computed({
      get: () => props.visible,
      set: v => emit('update:visible', v)
    });
    const form = reactive({
      targetColumnId: undefined
    });
    const errors = reactive({
      targetColumnId: ''
    });
    const submitting = ref(false);
    /**
     * 下拉选项：过滤掉当前栏目，避免移到自己
     */
    const columnOptions = computed(() => props.columns.filter(c => {
      var _props$module;
      return c.id !== ((_props$module = props.module) === null || _props$module === void 0 ? void 0 : _props$module.columnId);
    }).map(c => ({
      label: c.columnName || '未命名栏目',
      value: c.id
    })));
    /** 弹窗打开时重置表单 */
    watch(() => props.visible, v => {
      if (!v) return;
      form.targetColumnId = undefined;
      errors.targetColumnId = '';
    }, {
      immediate: true
    });
    const handleOk = async () => {
      if (submitting.value) return;
      if (!props.module) return;
      if (form.targetColumnId == null) {
        errors.targetColumnId = '请选择目标栏目';
        return;
      }
      errors.targetColumnId = '';
      submitting.value = true;
      try {
        const ok = await props.onSubmit({
          moduleId: props.module.id,
          fromColumnId: props.module.columnId,
          targetColumnId: form.targetColumnId
        });
        if (ok) {
          emit('update:visible', false);
        }
      } finally {
        submitting.value = false;
      }
    };
    const handleCancel = () => {
      emit('update:visible', false);
    };
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: _unref(open),
        "onUpdate:open": _cache[2] || (_cache[2] = $event => _isRef(open) ? open.value = $event : null),
        title: "移动模块",
        "confirm-loading": submitting.value,
        "mask-closable": false,
        "ok-text": "移动",
        "cancel-text": "取消",
        onOk: handleOk,
        onCancel: handleCancel
      }, {
        default: _withCtx(() => {
          var _props$module2, _props$module3;
          return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(((_props$module2 = __props.module) === null || _props$module2 === void 0 ? void 0 : _props$module2.moduleName) || '(未命名模块)'), 1), (_props$module3 = __props.module) !== null && _props$module3 !== void 0 && _props$module3.moduleCode ? (_openBlock(), _createElementBlock("code", _hoisted_5, _toDisplayString(__props.module.moduleCode), 1)) : _createCommentVNode("", true)])]), _createVNode(_component_a_form, {
            layout: "vertical",
            model: form,
            class: "move-form"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "目标栏目",
              required: "",
              "validate-status": errors.targetColumnId ? 'error' : '',
              help: errors.targetColumnId
            }, {
              default: _withCtx(() => [_createVNode(_component_a_select, {
                value: form.targetColumnId,
                "onUpdate:value": _cache[0] || (_cache[0] = $event => form.targetColumnId = $event),
                options: _unref(columnOptions),
                placeholder: "请选择目标栏目",
                onChange: _cache[1] || (_cache[1] = $event => errors.targetColumnId = '')
              }, null, 8, ["value", "options"])]),
              _: 1
            }, 8, ["validate-status", "help"])]),
            _: 1
          }, 8, ["model"])];
        }),
        _: 1
      }, 8, ["open", "confirm-loading"]);
    };
  }
});